import React from 'react';
import ListingCard from './ListingCard';

const HomePage = ({ 
  searchQuery, 
  setSearchQuery, 
  featured = [], 
  recent = [], 
  topRated = [], 
  loading, 
  error 
}) => {
  // Loading state UI
  if (loading) return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading listings...</p>
    </div>
  );
  
  // Error state UI
  if (error) return (
    <div className="error-container">
      <h2>Oops! Something went wrong</h2>
      <p>{error}</p>
      <button onClick={() => window.location.reload()}>Try Again</button>
    </div>
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="space-y-12 px-4">
        <section className="bg-card rounded-card shadow-card p-4 sm:p-6">
          <div className="flex items-center gap-2 mb-4 sm:mb-6">
            <div className="icon-container featured">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold">Featured Listings</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {featured.map(listing => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        </section>

        <section className="bg-card rounded-card shadow-card p-4 sm:p-6">
          <div className="flex items-center gap-2 mb-4 sm:mb-6">
            <div className="icon-container recent">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold">Recently Added</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {recent.map(listing => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        </section>

        <section className="bg-card rounded-card shadow-card p-4 sm:p-6">
          <div className="flex items-center gap-2 mb-4 sm:mb-6">
            <div className="icon-container top-rated">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
              </svg>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold">Top Rated</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {topRated.map(listing => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;
